const Coupon = () => import('./coupon.vue')
const TimeCard = () => import('./TimeCard.vue')
const TimesCard = () => import('./TimesCard.vue')
const ChooseCoupon = () => import('./ChooseCoupon.vue')
const MemberCard = () => import('./MemberCard.vue')
const ProductInfo = () => import('./ProductInfo.vue')
const SingleCard = () => import('./singleCard.vue')
const ACard = () => import('./ACard.vue')
const BCard = () => import('./BCard.vue')
const Cards = () => import('./Cards.vue')
const BuyCard = () => import('./BuyCard.vue')

export {
  Coupon,
  TimeCard,
  TimesCard,
  ChooseCoupon,
  MemberCard,
  ProductInfo,
  SingleCard,
  ACard,
  BCard,
  Cards,
  BuyCard
}



// WEBPACK FOOTER //
// ./src/pages/card/index.js